<div *ngIf="this.showNavBar">
    <div class="container-fluid">
        <div class="row wrapper">
            <div class="col-md-2 col-sm-3" id="sideNav">

                <!-- <app-sidenav></app-sidenav> -->
                <app-sidenav-v2></app-sidenav-v2>

            </div>
            <div class="col-md-10 col-sm-9">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <!-- <div class="justify-content-end">
        <footer class="footer">
            <div class="container-fluid">
                <p class="footerText">© 2020 <a style="text-decoration: none;color: #ffffff;" href="https://redlabs.tech">Redlabs.tech</a>
                    .
                    All rights reserved.</p>
            </div>
        </footer>
    </div> -->
</div>
<div *ngIf="!this.showNavBar && !this.isLoading">
    <router-outlet></router-outlet>
</div>